// PATH: SaberpDeals/frontend/src/lib/api.ts
import axios from 'axios';

// Token storage key — deliberately distinct from the ERP's 'azadControlAdmin'
// so the two apps never collide in the same browser.
export const TOKEN_KEY = 'saberpDeals';

export function getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

// All requests go to relative /api/... — Vite proxies to :5000 in dev; in prod
// the API serves the frontend from the same origin.
export const api = axios.create({ baseURL: '/' });

// Attach the bearer token on every request.
api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// On 401, the token is missing/expired — clear it and bounce to login.
api.interceptors.response.use(
    (r) => r,
    (error) => {
        if (error?.response?.status === 401) {
            clearToken();
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
